import React, { useEffect } from "react";
import { DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

import {
    HUBSPOT_ENTERPRISE_FORM_ID,
    HUBSPOT_PORTAL_ID,
    HUBSPOT_REGION,
    HUBSPOT_SCRIPT_ID,
    HUBSPOT_SCRIPT_URL,
    REVENUEHERO_ROUTER_ID,
    REVENUEHERO_SCRIPT_ID,
    REVENUEHERO_SCRIPT_URL
} from "js/config";
import { BeautifulDialog } from "js/react/components/Dialogs/BaseDialog";

export default function SalesFormDialog(props: { closeDialog?: () => void }) {
    const { t } = useTranslation();

    useEffect(() => {
        // Load HubSpot script
        if (!document.getElementById(HUBSPOT_SCRIPT_ID)) {
            const hubspotScript = document.createElement("script");
            hubspotScript.src = HUBSPOT_SCRIPT_URL;
            hubspotScript.id = HUBSPOT_SCRIPT_ID;
            hubspotScript.defer = true;
            document.body.appendChild(hubspotScript);
        }

        // Load RevenueHero script
        if (!document.getElementById(REVENUEHERO_SCRIPT_ID)) {
            const revenueHeroScript = document.createElement("script");
            revenueHeroScript.src = REVENUEHERO_SCRIPT_URL;
            revenueHeroScript.id = REVENUEHERO_SCRIPT_ID;
            revenueHeroScript.defer = true;
            revenueHeroScript.onload = () => {
                if ((window as any).RevenueHero) {
                    (window as any).hero = new (window as any).RevenueHero({ routerId: REVENUEHERO_ROUTER_ID });
                }
            };
            document.body.appendChild(revenueHeroScript);
        } else if ((window as any).RevenueHero && !(window as any).hero) {
            (window as any).hero = new (window as any).RevenueHero({ routerId: REVENUEHERO_ROUTER_ID });
        }
    }, []);

    return (
        <BeautifulDialog
            closeDialog={props.closeDialog}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>{t("Schedule an Enterprise Demo")}</DialogTitle>
            <DialogContent>
                <div
                    className="hs-form-frame"
                    data-region={HUBSPOT_REGION}
                    data-portal-id={HUBSPOT_PORTAL_ID}
                    data-form-id={HUBSPOT_ENTERPRISE_FORM_ID}
                ></div>
            </DialogContent>
        </BeautifulDialog>
    );
}
